<nav
  class="navbar navbar-expand navbar-dark fixed-top bg-theme nav-effect"
  style="padding: 0px 5px"
>
  <a class="navbar-brand ml-2" (click)="onBarsClick()"
    ><i class="fa fa-bars" aria-hidden="true" style="color:#fff"></i
  ></a>
  <!-- <a class="navbar-brand" routerLink="/dashboard"><div style="font-size: 22px; ">elevate</div></a> -->
  <img style="height: 32px; margin-left: 2px; width: 130px; border-radius: 0%; margin-bottom: 2px; " src="../../assets/img/elevate-logo.png" alt="">

  <ul class="navbar-nav ml-auto" style="color: white">
    <!-- <li class="nav-item">
      <a class="nav-link" href="#">Link</a>
    </li>

    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle" href="http://example.com" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Dropdown</a>
      <div class="dropdown-menu" aria-labelledby="dropdown03">
        <a class="dropdown-item" href="#">Action</a>
        <a class="dropdown-item" href="#">Another action</a>
        <a class="dropdown-item" href="#">Something else here</a>
      </div>
    </li>
    <li class="nav-item">
      <a class="nav-link disabled" href="#">Disabled</a>
    </li> -->
    <!-- <li class="nav-item mr-4">
      <a
        class="nav-link"
        style="color: white; cursor: pointer; font-size: 14px"
        (click)="onModalClick(modalContent)"
      >
        <i class="fa fa-key" aria-hidden="true" style="color:#fff"></i>&nbsp;Change Password</a
      >
    </li>-->
    <!-- <li class="nav-item">
      <a
        class="nav-link"
        (click)="onLogoutClick()"
        style="color: white; cursor: pointer; font-size: 14px"
        ><i class="fa fa-power-off" aria-hidden="true" style="color:#fff"></i> Logout</a
      >
    </li>  -->
    <li class="nav-item">
      <a
        class="nav-link"
        style="color: white; font-size: 16px"
        ><img [src]="userURL" style="width:35px;height:35px;"/>&nbsp;&nbsp;<span>{{userName}}</span></a
      >
    </li> 
  

    <li class="nav-item mt-1" data-toggle="dropdown" aria-expanded="true">
      <a class="nav-link"><i class="fa fa-ellipsis-v fa-lg" aria-hidden="true" style="color:#fff;cursor: pointer;"></i></a>
    </li>


  <div class="dropdown-menu dropdown-menu-right">
    <div class="profile-menu">
        <!-- <ul> -->
          <li class="nav-item btnStyle" >
            <a
              class="nav-link"
              style="color: #800000; cursor: pointer; font-size: 14px;margin-left:5px;"
              (click)="onModalClick(modalContent)"
            >
              <i class="fa fa-key" aria-hidden="true"></i>&nbsp;Change Password</a
            >
          </li>
          <li class="nav-item btnStyle">
            <a
              class="nav-link"
              (click)="onLogoutClick()"
              style="color: #800000; cursor: pointer; font-size: 14px;margin-left:5px;"
              ><i class="fa fa-power-off" aria-hidden="true"></i> Logout</a>
          </li> 
        <!-- </ul> -->
    </div>
</div>
  </ul>
</nav>

<ng-template #modalContent>
  <div class="modal-header bg-theme bg-theme-txt">
    <h3 class="modal-title mt-3 mb-3 ml-3" id="modal-basic-title ">
      Change Password
    </h3>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <form action="" [formGroup]="changePasswordForm">
      <div class="ml-5 mt-4">
        <label class="col-sm-4">New Password :</label>
        <div class="input-group col-sm-10">
          <input
            [type]="fieldTextType ? 'text' : 'password'"
            class="form-control"
            formControlName="newPass"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i
                class="fa"
                [ngClass]="{
                  'fa-eye-slash': !fieldTextType,
                  'fa-eye': fieldTextType
                }"
                (click)="toggleFieldTextType()"
              ></i>
            </span>
          </div>
        </div>
        <div
          *ngIf="submitted && changePasswordForm.controls['newPass'].invalid"
        >
          <div
            *ngIf="
              changePasswordForm.controls['newPass'].errors &&
              changePasswordForm.controls['newPass'].errors.required
            "
          >
            <span style="color: red" class="ml-3"
              >New Password is required.</span
            >
          </div>
        </div>
      </div>
      <div class="mt-4 ml-5 mb-5">
        <label class="col-sm-4">Confirm Password :</label>
        <div class="col-sm-10">
          <input
            type="text"
            class="form-control"
            formControlName="confirmPass"
          />
          <div
            *ngIf="
              submitted && changePasswordForm.controls['confirmPass'].invalid
            "
          >
            <div
              *ngIf="changePasswordForm.controls['confirmPass'].errors.required"
            >
              <span style="color: red">Confirm Password is required.</span>
            </div>
            <div
              *ngIf="
                changePasswordForm.controls['confirmPass'].errors.missMatch
              "
            >
              <span style="color: red">Passwords must match</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>

      <div class="col-sm-3">
        <button
          id="saveBtn"
          name="saveBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onSaveClick()"
        >
          Save
        </button>
      </div>

      <div class="col-sm-3">
        <button
          id="closeBtn"
          name="closeBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          ngbAutofocus
          (click)="closeModel()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
